<ng-template ngFor let-attivita [ngForOf]="attivitaList" let-indice=index>
	<li>
		<div class="documento row">
			<div class="codice col-sm-12">
				<p *ngIf="attivita.payload.sezione === 'notifica_fondo_rischi'">
					<a [routerLink]="['/fascicolo',getPraticaPathFromType(attivita.payload.idTipoPratica), tipoFascicoloString(attivita.payload.idTipoFascicolo), getSezioneDestinazione(attivita.payload.sezione), attivita.payload.idFascicolo]"
						title="data di notifica">{{attivita.dataNotifica| date:'dd/MM/yyyy'}}</a>
				</p>
				<p *ngIf="attivita.payload.sezione !== 'notifica_fondo_rischi'">
					<a *ngIf="!(attivita.payload.idTipoPratica === ID_PRATICA_PARERISTICA && getSezioneDestinazione(attivita.payload.sezione) === 'legali_fascicolo')"
						[routerLink]="['/inserimento/fascicolo',getPraticaPathFromType(attivita.payload.idTipoPratica), tipoFascicoloString(attivita.payload.idTipoFascicolo), getLabelInsert(), getSezioneDestinazione(attivita.payload.sezione), attivita.payload.idFascicolo]"
						title="data di notifica">{{attivita.dataNotifica| date:'dd/MM/yyyy'}}</a>
				</p>
			</div>
			<div class="col-sm-12">
				<p class="descrizione">{{attivita.testo}}</p>
			</div>
			<div class="col-sm-12">
				<p *ngIf="attivita.giorniRitardo" class="notifica">
					Notificata da <span>{{attivita.giorniRitardo + ' gg'}}</span>
				</p>
			</div>
		</div>
	</li>
</ng-template>